import { openURL } from "../../../utils/sideEffects";

export const openItemIssueUrl = (): Promise<void> => {
  const url =
    "https://docs.google.com/forms/d/e/1FAIpQLSehwNsVgyC3QZckz61lRNNKbwvB3R_gYDQ4eZQNwgdXbphTSQ/viewform?usp=sf_link";
  return openURL(url);
};
